<script lang="ts">
    import {modal, dyData} from 'general/store';
    import {ANIMATION_DURATION, STATE, TEMPLATE} from 'general/constants';
    import {fade} from 'svelte/transition';
    import Position from 'desktop/components/position/Position.svelte';

    import Theme from 'general/theme/Theme.svelte';
    import MainSide from './state/Main.svelte';
    import FlipWrapper from 'general/components/flip/wrapper/FlipWrapper.svelte';
    import Backdrop from 'general/components/backdrop/Backdrop.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import type {AxiosInstance} from 'axios';
    import {getData} from 'general/libs/dy/getData';
    import type {AxiosResponse} from 'axios';
    import type {
        DyCustomJsonResponseType,
        ProductRecommendationType,
        SortedDyRecommendationsType,
    } from 'types/dy';
    import {
        getDyDataBySelector,
        getSortedRecommendationsData,
    } from 'general/libs/dy/normalizeResponse';
    import {onMount} from 'svelte';
    import {EXTRA_CAROUSEL_PROPS, DY_REQUEST_RECOMMENDATIONS_DATA} from './constants';

    export let instanceDY: AxiosInstance;

    let recommendations: ProductRecommendationType[];

    const OPTIONS = {
        [STATE.MAIN]: {component: MainSide, props: {}},
    } as const;

    onMount(() => {
        if (!instanceDY) return;
        getData(instanceDY, DY_REQUEST_RECOMMENDATIONS_DATA, EXTRA_CAROUSEL_PROPS).then(
            (response: AxiosResponse<DyCustomJsonResponseType>) => {
                const data: SortedDyRecommendationsType = getSortedRecommendationsData(
                    getDyDataBySelector(response.data),
                );
                recommendations = data.value.D_Exit_Recommendations ?? [];
            },
        );
    });
</script>

<div>
    <div transition:fade={{duration: ANIMATION_DURATION.MODAL}}>
        <Position>
            <FlipWrapper template={TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS}>
                <Theme
                    template={TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS}
                    color={$dyData.side.main.backgroundColor}
                >
                    <svelte:component
                        this={OPTIONS[$modal.state].component}
                        {...OPTIONS[$modal.state].props}
                        {recommendations}
                    />
                    <CloseButton
                        handleClick={modal.close}
                        theme={TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS}
                        crossColor={'#898989'}
                    />
                </Theme>
            </FlipWrapper>
        </Position>
        <Backdrop />
    </div>
</div>
